import React from 'react'
import { Label } from './Label'

const DEFAULT_FORMAT = 'en-US'

export interface IFormattedValueProps {
  children?: string | number
  currency?: boolean
  emissions?: boolean
  percentage?: boolean
  time?: boolean
  withFractions?: boolean
}

export const FormattedValue = ({
  children,
  currency,
  emissions,
  percentage,
  time,
  withFractions,
}: IFormattedValueProps) => {
  if (!children) {
    return null
  }

  const numberFormatter = new Intl.NumberFormat(DEFAULT_FORMAT, {
    minimumFractionDigits: withFractions ? 2 : 0,
    maximumFractionDigits: withFractions ? 2 : 0,
  })

  if (emissions) {
    return (
      <>
        {parseFloat(String(children)).toFixed(2)}
        <Label>CO2 Metric Tons</Label>
      </>
    )
  }

  if (percentage) {
    return (
      <>
        {parseInt(String(children), 10)}
        <Label>%</Label>
      </>
    )
  }

  if (currency) {
    return (
      <>
        <Label>$</Label>
        {numberFormatter.format(Number(children))}
      </>
    )
  }

  if (time && typeof children === 'string') {
    const numberTime = Number(children)
    const hours = parseInt(children, 10)
    const minutes = (numberTime - Math.floor(numberTime)) * 60
    const hoursToRender =
      hours > 0 ? (
        <>
          {hours} <Label>hrs</Label>
        </>
      ) : null
    const minutesToRender =
      minutes > 0 ? (
        <>
          {parseInt(`${minutes}`, 10)} <Label>min</Label>
        </>
      ) : null
    return (
      <>
        {hoursToRender} {minutesToRender}
      </>
    )
  }

  return <>{numberFormatter.format(typeof children === 'string' ? Number(children) : children)}</>
}
